import './polyfills';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { appConfig } from './app/app.config';

registerLocaleData(localeEs, 'es');

/* eslint-disable no-console */
bootstrapApplication(AppComponent, {
  providers: [...(appConfig.providers ?? [])],
})
  .then(() => {
    const appRoot = document.querySelector('app-root');
    if (appRoot?.hasAttribute('ng-version')) {
      appRoot.removeAttribute('ng-version');
    }
  })
  .catch((err) => console.error(err));
